import ConditionType from './ConditionType'

const LessThanCondition: ConditionType = {
  value: 'less than',
  label: 'Less Than',
  hasRHS: true,
}

export default LessThanCondition
